import React, {FunctionComponent} from 'react';
import {Page} from 'b302-frontend-library';
import {useQuery} from '@tanstack/react-query';

import {useSubjectAreaIndexQueryConfig} from '../../../query/SubjectArea/Query';
import SubjectAreasContent from './SubjectAreasContent';

const SubjectAreas: FunctionComponent = () => {

    const [subjectAreaConfig] = useSubjectAreaIndexQueryConfig();
    const subjectAreaQuery = useQuery(subjectAreaConfig);

    return (
        <Page className={'admin-subject-areas-page'}>
            { subjectAreaQuery.data &&
                <SubjectAreasContent
                    subjectAreas={subjectAreaQuery.data} />
            }
        </Page>
    );
};

export default SubjectAreas;
